import React from 'react';
import Immutable from 'immutable';
import ParentBoundComponent from '../../components/parentboundcomponent';
import Accordion from '../../components/containers/accordion';
import ModuleSelectorModel from './moduleselectormodel';
import FlexBox from '../../components/containers/flexbox';
import FlexBoxBlock from '../../components/containers/flexboxblock';
import Module from '../module';
import Centerer from '../../components/containers/centerer';
import SimpleIconMenu from '../../components/menu/simpleiconmenu';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);

export default class ModuleSelectorModule extends ParentBoundComponent {
	constructor() {
		super();
		this.setSelectedItem = this.setSelectedItem.bind(this);
		this.setExpandedFolder = this.setExpandedFolder.bind(this);
	}

	getModel() {
		return new ModuleSelectorModel(this.getData());
	}

	setModelData(model) {
		this.setData(model.getData());
	}

	setExpandedFolder(folderName) {
		this.setModelData(this.getModel().setExpandedFolder(folderName));
	}

	setSelectedItem(folderName, itemName) {
		this.setModelData(this.getModel().setSelectedItem(folderName, itemName));
	}

	renderDefault() {
		if (this.props.renderDefault) {
			return this.props.renderDefault();
		} else {
			return null;
		}
	}

	render() {
		const data = this.getData();
		const selectedFolderName = data.get('selectedFolderName');
		const selectedItemName = data.get('selectedItemName');
		const selectedModuleState = selectedItemName ? data.getIn(['modules', selectedFolderName, selectedItemName]) : null;
		return (
			<FlexBox>
				{
					data.get('moduleSelectorHidden') ? (
						<SimpleIconMenu
							folders={data.get('folders')}
							expandedFolderName={data.get('expandedFolderName')}
							selectedFolderName={selectedFolderName}
							selectedItemName={selectedItemName}
							onFolderExpanded={this.setExpandedFolder}
							onItemSelected={this.setSelectedItem}
						/>
					) : (
						<FlexBoxBlock width="240px" flexShrink="0">
							<Accordion
								folders={data.get('folders')}
								expandedFolderName={data.get('expandedFolderName')}
								selectedFolderName={selectedFolderName}
								selectedItemName={selectedItemName}
								onFolderExpanded={this.setExpandedFolder}
								onItemSelected={this.setSelectedItem}
							/>
						</FlexBoxBlock>
					)
				}
				<FlexBoxBlock flexGrow="1" padding="8px 24px">
					{
						selectedModuleState ? (
							<Module
								key={selectedFolderName+'/'+selectedItemName}
								appState={selectedModuleState}
								onDataChange={data => {
									this.setModelData(this.getModel().setModuleData(selectedFolderName, selectedItemName, data));
								}}
							/>
						) : this.renderDefault()
					}
				</FlexBoxBlock>
			</FlexBox>
		);
	}
}
